export enum EmbedOptionEnum {
  CHART = "chart",
  ODDS = "odds",
  CONSENSUS_ONLY = "consensusOnly",
  BORDER = "border",
  DARK_MODE = "darkMode",
}

export type EmbedOptionsState = Record<EmbedOptionEnum, boolean>;

export enum EmbedDimensionEnum {
  HEIGHT = "height",
  WIDTH = "width",
}
